import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { AAJEEVIKA_EPDT_STATUS_REVERSE_MAP } from '../../../../../../_constants/aajeevika/aajeevika.constants';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { CUSTOMCOLUMNEVENT } from '../../../../../../_models/table.model';
import { USER_PROFILE } from '../../../../../../_models/user.model';
import { StatesMasterList } from '../../../../../../_models/geo.model';
import { LocalService } from '../../../../../../_services/_storage/local.service';
import { CdnService } from '../../../../../../_services/_cdn/cdn.service';
import { SnackbarService } from '../../../../../../_services/snackbar/snackbar.service';
import { STATES } from '../../../../../../_constants/states';
import { AppSettingService } from '../../../../../../_services/_appSetting/app-setting.service';
import { theme } from '../../../../../../_constants/appSetting.constant';
import { roles } from '../../../../../../_constants/roles';

@Component({
    selector: 'lokos-custom-column',
    templateUrl: './custom-column.component.html',
    styleUrl: './custom-column.component.scss',
    standalone: false,
})
export class CustomColumnComponent implements OnInit, OnDestroy {
    @Input() columnDetails: any;
    @Input() rowData: any;
    @Input() entity: any;
    @Output() componentEvent: EventEmitter<CUSTOMCOLUMNEVENT> =
        new EventEmitter<CUSTOMCOLUMNEVENT>();

    userRoles: string[] | any = this.localService.get('userRoles');
    userProfile: USER_PROFILE | any = this.localService.get('userProfile');

    stateList: StatesMasterList[] = STATES;
    districtList: any[] = [];
    cboNameList: any[] = [];

    inputValueChanges = new Subject<string>();
    selectedtheme!: string;
    appTheme = theme;
    subScription: Subscription[] = [];

    geoLoction: any;
    roles = roles;

    constructor(
        private localService: LocalService,
        private cdnService: CdnService,
        private snackbarService: SnackbarService,
        private datePipe: DatePipe,
        private appSettingService: AppSettingService
    ) {}

    ngOnInit(): void {
        this.geoLoction = this.appSettingService.geoLocations;
        const theme = this.appSettingService.appTheme$.subscribe((theme) => {
            this.selectedtheme = theme;
        });

        this.subScription.push(theme);

        const inputValueChangesSub = this.inputValueChanges
            .pipe(debounceTime(500))
            .subscribe((value: string) => {
                this.componentEvent.emit({
                    row: this.rowData,
                    column: {
                        ...this.columnDetails,
                        ...{ isButtonClicked: false },
                    },
                    updatedValue: value,
                    entity: this.entity,
                });
            });

        this.subScription.push(inputValueChangesSub);
    }

    onButtonClick() {
        this.componentEvent.emit({
            row: this.rowData,
            column: this.columnDetails,
            updatedValue: null,
            entity: this.entity,
        });
    }

    onReportLinkClick() {
        this.componentEvent.emit({
            type: this.columnDetails?.event,
            row: this.rowData,
            column: this.columnDetails,
            updatedValue: null,
            entity: this.entity,
        });
    }

    handleTransactionClick(isDisabled: boolean) {
        if (isDisabled) return;
        this.onButtonClick();
    }

    onInput($event: any) {
        this.inputValueChanges.next($event.target.value);
    }

    onIconClick() {
        this.componentEvent.emit({
            row: this.rowData,
            column: this.columnDetails,
            updatedValue: null,
            entity: this.entity,
        });
    }

    onLinkClick(code: string) {
        this.componentEvent.emit({
            row: this.rowData,
            column: this.columnDetails,
            updatedValue: code,
            entity: this.entity,
        });
    }

    afterSelectionChange($event: any) {
        this.componentEvent.emit({
            row: this.rowData,
            column: this.columnDetails,
            updatedValue: $event,
            entity: this.entity,
        });
    }

    afterDateChange($event: any) {
        this.componentEvent.emit({
            row: this.rowData,
            column: this.columnDetails,
            updatedValue: new Date($event.value).toISOString(),
            entity: this.entity,
        });
    }

    onFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (input?.files?.length) {
            this.componentEvent.emit({
                row: this.rowData,
                column: this.columnDetails,
                updatedValue: input.files,
                entity: this.entity,
            });
        }
    }

    onDateChange($event: any) {
        this.componentEvent.emit({
            row: this.rowData,
            column: this.columnDetails,
            updatedValue: $event,
            entity: this.entity,
        });
    }

    getEpdtStatus(status: number): string {
        return AAJEEVIKA_EPDT_STATUS_REVERSE_MAP[status] ?? 'Unknown';
    }

    getLocation() {
        if (this.rowData.block && this.rowData.block !== '-') {
            const block = this.geoLoction.find(
                (item: any) => item.block_id === 'B-' + this.rowData.block
            );
            if (block) {
                return `<b>State:</b>&nbsp;${block.state_name}
        <b>District:</b>&nbsp;${block.district_name}
        <b>Block:</b>&nbsp;${block.block_name}`;
            }
        }
        if (this.rowData.district && this.rowData.district !== '-') {
            const district = this.geoLoction.find(
                (item: any) => item.district_id === 'D-' + this.rowData.district
            );
            if (district) {
                return `<b>State:</b>&nbsp;${district.state_name}
        <b>District:</b>&nbsp;${district.district_name}`;
            }
        }
        if (this.rowData.state && this.rowData.state !== '00') {
            const state = this.geoLoction.find(
                (item: any) => item.state_id === 'S-' + this.rowData.state
            );
            if (state) {
                return `<b>State:</b>&nbsp;${state.state_name}`;
            }
        }
        return '';
    }

    getFixedArray(count = 3): number[] {
        return Array.from({ length: count });
    }

    ngOnDestroy(): void {
        this.subScription.forEach((sub: Subscription) => {
            sub.unsubscribe();
        });
    }
}
